import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FullPageSpinner } from './Spinner';

// Gates a route on an authenticated session; redirects to /login otherwise.
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullPageSpinner />; // session restore in flight
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
